import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import de from "./locales/de.json";

const resources = {
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
};

// Get the stored language from localStorage or default to 'en'
const getStoredLanguage = (): string => {
  const storedLang = localStorage.getItem("i18nextLng");
  // Validate that the stored language is one we support
  if (storedLang && (storedLang === "en" || storedLang === "de")) {
    return storedLang;
  }
  return "en"; // Default to English
};

// Initialize i18n
await i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: true,
    lng: getStoredLanguage(), // Load from localStorage or default to 'en'
    ns: ["translation"],
    defaultNS: "translation",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
